import axiosInstances from '@/../../coreui/server/axiosInstances.js'
import loginStore from '@/../../coreui/store/login.js'
export default {
    methods: {
        async getUserPreference(key) {
            let prefItem
            try {
                this.elog('trace', 'key = {}, uid = {}', key, loginStore.state.origLoggedinUser)()
                prefItem = await axiosInstances.origApiServer.get('/dt/v1/set_preferences?uid=' + loginStore.state.origLoggedinUser._id)
                this.elog('trace', 'key = {}, uid = {}, rec={}', key, loginStore.state.origLoggedinUser, prefItem)()
                if (prefItem == null || prefItem.data == null || prefItem.data.length == 0 ||
                    !prefItem.data[0][key]) {
                    this.elog('trace', 'No preference record found')()
                    return null
                }
                let val = prefItem.data[0][key]
                this.elog('debug', 'Preference fetched for {} is {}', key, val)()
                console.log('get user pref', key, val)
                return val
            } catch (e) {
                this.elog('trace', 'Preference fetch failed for user {}', loginStore.state.origLoggedinUser.email)()
                return null
            }
        },

        async setUserPreference(skey, value) {
            let prefItem
            let obj = {}
            try {
                prefItem = await axiosInstances.origApiServer.get('/dt/v1/set_preferences?uid=' + this.origLoggedinUser._id)
                if (prefItem != null && prefItem.data != null && prefItem.data.length > 0) {
                    obj[skey] = value
                    axiosInstances.origApiServer.patch('/dt/v1/set_preferences/' + prefItem.data[0]._id, obj)
                } else {
                    obj = {
                        'uid': this.loggedinUser.uid
                    }
                    obj[skey] = value
                    axiosInstances.origApiServer.post('/dt/v1/set_preferences', obj)
                }
            } catch (e) {
                this.elog('trace', 'Preference fetch failed for user {}', this.origLoggedinUser.email)()
                obj = {
                    'uid': this.loggedinUser.uid
                }
                obj[skey] = value
                axiosInstances.origApiServer.post('/dt/v1/set_preferences', obj)
            }
        }
    }
}